exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 991.98px){\n.page-dakea .product-info__specifications{width:100%\n}\n}\n@media (max-width: 767.98px){\n.page-dakea .product-info__category img{width:100%\n}\n}\n@media (max-width: 575.98px){\n.page-dakea .product-info__category img{width:auto\n}\n.page-dakea .product-info__specifications li{display:block\n}\n.page-dakea .product-info__specifications li strong{display:block;width:100%\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d1779d84","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/dakeaProducts.vue
// module id = 104
// module chunks = 0